/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Intro_Region_Island_Nations_DescriptionInputs */

const bn_intro_region_island_nations_description = /** @type {(inputs: Intro_Region_Island_Nations_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`স্বতন্ত্র উপকূলরেখা সহ মহাসাগর-ভারী দৌড়।`)
};

const de_intro_region_island_nations_description = /** @type {(inputs: Intro_Region_Island_Nations_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meeresreiche Abfahrten mit ausgeprägten Küstenlinien.`)
};

const el_intro_region_island_nations_description = /** @type {(inputs: Intro_Region_Island_Nations_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Δρόμοι γεμάτους ωκεανούς με ευδιάκριτες ακτές.`)
};

const en_intro_region_island_nations_description = /** @type {(inputs: Intro_Region_Island_Nations_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ocean-heavy runs with distinct coastlines.`)
};

const es_intro_region_island_nations_description = /** @type {(inputs: Intro_Region_Island_Nations_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Corredores llenos de océanos con costas distintas.`)
};

const fr_intro_region_island_nations_description = /** @type {(inputs: Intro_Region_Island_Nations_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parties maritimes avec des côtes bien distinctes.`)
};

const hi_intro_region_island_nations_description = /** @type {(inputs: Intro_Region_Island_Nations_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अलग-अलग तटरेखाओं के साथ महासागर-भारी धाराएँ।`)
};

const hu_intro_region_island_nations_description = /** @type {(inputs: Intro_Region_Island_Nations_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Óceánban sűrű pályák, különálló partvonalakkal.`)
};

const id_intro_region_island_nations_description = /** @type {(inputs: Intro_Region_Island_Nations_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jalur padat lautan dengan garis pantai yang berbeda.`)
};

const it_intro_region_island_nations_description = /** @type {(inputs: Intro_Region_Island_Nations_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Piste oceaniche con coste distinte.`)
};

const ja_intro_region_island_nations_description = /** @type {(inputs: Intro_Region_Island_Nations_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`独特の海岸線を持つ、海洋性の高いコース。`)
};

const ko_intro_region_island_nations_description = /** @type {(inputs: Intro_Region_Island_Nations_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`뚜렷한 해안선이 있는 바다가 많은 코스입니다.`)
};

const nl_intro_region_island_nations_description = /** @type {(inputs: Intro_Region_Island_Nations_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oceaanzware afdalingen met verschillende kustlijnen.`)
};

const pl_intro_region_island_nations_description = /** @type {(inputs: Intro_Region_Island_Nations_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trasy obfitujące w oceany z wyraźnymi liniami brzegowymi.`)
};

const pt_intro_region_island_nations_description = /** @type {(inputs: Intro_Region_Island_Nations_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Percursos intensos no oceano com litorais distintos.`)
};

const ru_intro_region_island_nations_description = /** @type {(inputs: Intro_Region_Island_Nations_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Океанские участки с четко выраженными береговыми линиями.`)
};

const sv_intro_region_island_nations_description = /** @type {(inputs: Intro_Region_Island_Nations_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Havstunga pister med distinkta kustlinjer.`)
};

const tr_intro_region_island_nations_description = /** @type {(inputs: Intro_Region_Island_Nations_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Farklı kıyı şeritlerine sahip, okyanus ağırlıklı parkurlar.`)
};

const uk_intro_region_island_nations_description = /** @type {(inputs: Intro_Region_Island_Nations_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Океанські смуги з чіткими береговими лініями.`)
};

const vi_intro_region_island_nations_description = /** @type {(inputs: Intro_Region_Island_Nations_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Các đường chạy có nhiều đại dương với đường bờ biển riêng biệt.`)
};

const zh_intro_region_island_nations_description = /** @type {(inputs: Intro_Region_Island_Nations_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`海洋重道，海岸线独特。`)
};

const zh_hant_intro_region_island_nations_description = /** @type {(inputs: Intro_Region_Island_Nations_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`海洋重道，海岸線獨特。`)
};

/**
* | output |
* | --- |
* | "Ocean-heavy runs with distinct coastlines." |
*
* @param {Intro_Region_Island_Nations_DescriptionInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const intro_region_island_nations_description = /** @type {((inputs?: Intro_Region_Island_Nations_DescriptionInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Intro_Region_Island_Nations_DescriptionInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_intro_region_island_nations_description(inputs)
	if (locale === "de") return de_intro_region_island_nations_description(inputs)
	if (locale === "el") return el_intro_region_island_nations_description(inputs)
	if (locale === "en") return en_intro_region_island_nations_description(inputs)
	if (locale === "es") return es_intro_region_island_nations_description(inputs)
	if (locale === "fr") return fr_intro_region_island_nations_description(inputs)
	if (locale === "hi") return hi_intro_region_island_nations_description(inputs)
	if (locale === "hu") return hu_intro_region_island_nations_description(inputs)
	if (locale === "id") return id_intro_region_island_nations_description(inputs)
	if (locale === "it") return it_intro_region_island_nations_description(inputs)
	if (locale === "ja") return ja_intro_region_island_nations_description(inputs)
	if (locale === "ko") return ko_intro_region_island_nations_description(inputs)
	if (locale === "nl") return nl_intro_region_island_nations_description(inputs)
	if (locale === "pl") return pl_intro_region_island_nations_description(inputs)
	if (locale === "pt") return pt_intro_region_island_nations_description(inputs)
	if (locale === "ru") return ru_intro_region_island_nations_description(inputs)
	if (locale === "sv") return sv_intro_region_island_nations_description(inputs)
	if (locale === "tr") return tr_intro_region_island_nations_description(inputs)
	if (locale === "uk") return uk_intro_region_island_nations_description(inputs)
	if (locale === "vi") return vi_intro_region_island_nations_description(inputs)
	if (locale === "zh") return zh_intro_region_island_nations_description(inputs)
	return zh_hant_intro_region_island_nations_description(inputs)
});